import React from 'react'
import "./Slider.scss";
export default function ThreeImage() {
  return (
    
    <>
    
    <div className='textSlide'>
        <p>SUGAR BEAUTY BLOG</p>
    </div>
    <div className='threeImage'>
        <img src="https://adminblog.s3.ap-south-1.amazonaws.com/image/97L3SpnG51920x453%20%282%29.jpg" alt="" />
        <img src="https://adminblog.s3.ap-south-1.amazonaws.com/image/1920x453.jpg.jpg" alt="" />
        <img src="https://adminblog.s3.ap-south-1.amazonaws.com/image/OPV813-sYWays-to-stop-your-scalp-from-flaking_1920x453.jpg" alt="" />
    </div>
    
    
    </>

  )
}
